export function studentsCountByStatus(data) {
    const state = {
        "COMPLETED": 0,
        "FINISHED": 0,
        "PENDING": 0,
        "STARTED": 0,
        "NOT_STARTED": 0,
        "IN_PROGRESS": 0,
    }
    data.forEach(element => {
        if (!element.completionStatus) {
        state[element.progressStatus] += 1
        } else {
            state[element.completionStatus] += 1
        }
    });
    return state;
}